import { createReducer, on } from '@ngrx/store';
import { initialProviderState, ProviderState } from './provider.state';
import { ProviderActions } from './provider.actions';

export const providerReducer = createReducer<ProviderState>(
  initialProviderState,
  on(ProviderActions.loadProvidersSuccess, (state, { providers }) => {
    return { ...state, providers: providers, error: undefined };
  }),
  on(ProviderActions.loadProvidersError, (state, { error }) => {
    return { ...state, providers: [], error: error };
  })
);
